import { Label, LabelGroup } from 'semantic-ui-react'
import { Transaction } from '@/reducers/admin/allTransactions.slice'

const ReceiptTag = ({ receipts }: { receipts: number | null | undefined }) => {
  if (!receipts) return null
  return <Label>Receipts</Label>
}

const RowTags = ({ row }: { row: Transaction }) => (
  <LabelGroup>
    {row.manuallyCreated && <Label>Manual</Label>}
    {row.confirmedAt && <Label color="green">Confirmed</Label>}
    {row.requestedClarificationAt && (
      <Label color="red">Clarification Requested</Label>
    )}
    {row.manuallyDedupedAt && <Label color="yellow">Marked as Duplicate</Label>}
    <ReceiptTag receipts={row._count?.receipts} />
  </LabelGroup>
)

export default RowTags
